
export default {
    init() {
    },
    finalize() {
        function toggleCartModal(e) {
            e.preventDefault();
            
            var wrapper = $('.cart-modal');
            var backdrop = $('#backdrop.cart-modal-controler');
    
            if(wrapper.hasClass('open')) {
                wrapper.removeClass('open');
                backdrop.removeClass('active');
                return;
            }
            
    
            backdrop.addClass('active');
            wrapper.addClass('open');
        }
    
        $('a[href="#open-cart-modal"]').click(toggleCartModal);
        $('.cart-modal-controler').click(toggleCartModal);

        $('.cart-modal').on('change', 'input.quantity', function() {
            if (this.value === '0')
                this.value = '1';

            $(this.form).find('button[data-quantity]').data('quantity', this.value);
        });
    },
}



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js